import { isEmpty, toString } from "lodash";
import axios from 'axios'
const config = require('../../config.json');
const common = require('../helpers/common');
var baseUrl = config.clarityPayMiddlewareUrl;

export default {
    data() {
        return {
            baseUrl: baseUrl,
        }
    },
    computed: {
        lookupConditionOptions() {
            return [
                { text: 'Equal', value: '=' },
                { text: 'In', value: 'IN' },
                { text: 'Less Than', value: '<' },
                { text: 'Greater Than', value: '>' },
                { text: 'Less Than Equal', value: '<=' },
                { text: 'Greater Than Equal', value: '>=' },
                { text: 'Between', value: 'between' },
            ]
        },
        fieldNameOptoins() {
            return [
                {
                    text: 'PaymentType', value: "allowedPaymentType"
                },
                {
                    text: 'CreditCard', value: "allowedCCList"
                },
                {
                    text: 'DebitCard', value: "allowedDCList"
                },
                {
                    text: 'ThreeDs', value: "allowedThreeDs"
                },
                {
                    text: 'Currencies', value: "allowedCurrencies"
                },
                {
                    text: 'DefaultCurrency', value: "defaultCurrency"
                }
            ]
        },
        attributeTypeOptions() {
            return [
                { value: 'S', text: 'String' },
                { value: 'I', text: 'Integer' },
                { value: 'C', text: 'Collection' },
            ];
        },
        businessTypeOptions() {
            return [
                { value: 'T', text: 'Travel' },
                { value: 'E', text: 'E-Commerce' }
            ]
        },
        productTypeOptions() {
            return [
                { value: 'F', text: 'Flight' },
                { value: 'C', text: 'Car' },
                { value: 'H', text: 'Hotel' },
                { value: 'I', text: 'Insurance' },
                { value: 'TU', text: 'Tour' },
                { value: 'TR', text: 'Transfers' }
            ]
        },
        StatusOptions() {
            return [
                { value: 'A', text: 'Active' },
                { value: 'IA', text: 'InActive' }
            ]
        },
        isInternalOptions() {
            return [
                { value: 'Y', text: 'Yes' },
                { value: 'N', text: 'No' }
            ]
        },
        yesOrNoOptions() {
            return [
                { value: 'yes', text: 'Yes' },
                { value: 'no', text: 'No' }
            ]
        },
        pgStatusOptions(){
            return [
                { text: 'External', value: 'E' }, 
                { text: 'Internal', value: 'I' }
            ]
        },
        preferedModeOptions(){
            return [
                { text: 'Preferred Routing', value: '1' }, 
                { text: 'Smart Routing', value: '2' }
            ]
        },
        allowedPaymentTypes(){
            return [
                { text: 'Credit Card', value: 'CC' },
                { text: 'Debit Card', value: 'DC' },
                { text: 'Cash', value: 'CASH' },
                { text: 'ACH', value: 'ACH' },
                { text: 'PG', value: 'PG' },
                { text: 'CHEQUE', value: 'CHEQUE'}
            ]
        },
        allowedCards() {
            return [
                { text: 'American Express', value: 'AX' },
                { text: 'MasterCard', value: 'MC' },
                { text: 'Visa', value: 'VI' },
                { text: 'Diners Club', value: 'DC' },
                { text: 'JCB', value: 'JC' },
                { text: 'Maestro', value: 'MA' },
                { text: 'Discover', value: 'DS' },
                { text: 'Rupay Card', value: 'RU' }
            ]
        },
        permissions() {
            return this.$store.state.permissions;
        },
        userPermissions() {
            return this.$store.state.userPermissionArray;
        },
        ModuleName() {
            return {
                MerchantApiKey: 'MerchantApiKey',
                Merchant: 'Merchant',
                MerchantPos: 'MerchantPos',
                Customer: 'Customer',
                PgCredential: "Payment gateway credential",
                Role: 'Role',
                Permission: 'Permission',
                User: 'User',
                Pos: 'Merchant pos',
                PaymentGateWay: 'PaymentGateWay',
                RoutingAttribute: 'RoutingAttribute',
                MerchantGateway: 'MerchantPaymentGateway',
                RoutingRule: 'Merchant attribute routing rule',
                PaymentLink: 'Payment Link',
                Refund: 'Refund successfully.'
            }
        },
    },
    methods: {
        ...common,
        hasModulePermissions(moduleName){
            return !isEmpty(this.permissions) ? this.permissions.includes(moduleName) : false;
        },
        navigateTo(name, data=null) {
            if (!isEmpty(data)) {
                this.$store.commit(name, data);
            }
            this.$router.push(`/${name}`);
        },
        isAuthenticated() {
            return localStorage.getItem('login') !== null;
        },
        getStoredObject(name) {
            return this.$store.state[name];
        },
        createNotificationMessage(message) {
            this.$notificationMessage({message:this.createMessage(message)});
        },
        updateNotificationMessage(message) {
            this.$notificationMessage({message:this.updateMessage(message)});
        },
        deleteNotificationMessage(message) {
            this.$notificationMessage({message: this.deleteMessage(message), alert:'danger'});
        },
        copyNotificationMessage(message) {
            this.$notificationMessage({message: this.copyMessage(message)});
        },
        commonNotificationMessage(message) {
            this.$notificationMessage({message: this.commonMessage(message), alert:'danger'});
        },
        hasRolePermission(module) {
            if (!isEmpty(this.permissions)) {
                return this.permissions.some(item => item === module);
            }
        },
        updateDeleteTable(updateCol, deleteCol) {
            const updateDeleteArray = [];
            if (this.hasRolePermission(updateCol) || this.hasRolePermission(deleteCol)) {
                if(this.hasRolePermission(updateCol)) {
                    updateDeleteArray.push('update');
                }
                if(this.hasRolePermission(deleteCol)) {
                    updateDeleteArray.push('delete');
                }
            }
            return updateDeleteArray;
        },
        hasFieldsValue(ObjectValue) {
            for (const [Key, Value] of Object.entries(ObjectValue)) {
                console.log(Key, '==', toString(this[Key]));
                ObjectValue[Key] = isEmpty(toString(this[Key]));
            }
            console.log(ObjectValue);
            const errorStatus = Object.values(ObjectValue).some(status => status === true);
            console.log(errorStatus);
            return errorStatus;
        },

        ApiCurlRequest(endpoint, data, apiReqType) {
            let apiResponse;
            let sessionToken = null;
            let encCred = null;
        
            if (localStorage.getItem('login'))
                encCred = localStorage.getItem('login');
        
            if (localStorage.getItem('token'))
                sessionToken = localStorage.getItem('token');
        
            const requestConfig = {
                headers: {
                    'authorization': config.authorization,
                    'Content-Type': config.contentType,
                    'Authorization': encCred,
                    'merchant-token': sessionToken
                }
            };
            switch (apiReqType) {
                case 'get':
                    apiResponse = axios.get(baseUrl + endpoint, requestConfig);
                    break;
                case 'post':
                    apiResponse = axios.post(baseUrl + endpoint, data, requestConfig);
                    break;
                case 'put':
                    apiResponse = axios.put(baseUrl + endpoint, data, requestConfig);
                    break;
                case 'delete':
                    apiResponse = axios.delete(baseUrl + endpoint, requestConfig);
                    break;
            }
        
            return apiResponse;
        }

    },
};
